import { useContext, useState } from 'react'

import { ENTITY_LISTING_VIEW_TYPE } from '../../../../../constants/common'
import { Screen } from '../../../../../context'
import { useMultipleViewTypeList } from '../../../../MultipleViewTypeList'
import {
  getMockIntegrationsConfig,
  patchMockIntegrationsConfig,
} from '../../RentalPortalIntegrations.mocks'
import { getIsIntegrationsSplitAvailable } from '../../RentalPortalIntegrations.utils'

export function useRentalPortalIntegrationsViewRegime(portals) {
  const { width } = useContext(Screen)

  const [config, setConfig] = useState(getMockIntegrationsConfig)
  const [modalPortal, setModalPortal] = useState(null)

  function handleSetView(view) {
    setConfig(current => ({ ...current, view }))
  }

  function handleSetPreview(preview) {
    setConfig(current => ({ ...current, preview }))
  }

  const {
    activeItem,
    handleChangeFocusedRow,
    handleChangeViewType,
    handlePreviewResizeEnd,
    handleResetViewTypeToPlainBody,
  } = useMultipleViewTypeList({
    handleSetPreview,
    handleSetView,
    handleUpdateConfig: patchMockIntegrationsConfig,
    items: portals,
    listViewType: config.view,
    preview: config.preview,
  })

  function handleCloseModal() {
    setModalPortal(null)
  }

  function handleSelectPortal(connection) {
    if (getIsIntegrationsSplitAvailable(width)) {
      handleChangeViewType(ENTITY_LISTING_VIEW_TYPE.tableWithPreview)
      handleChangeFocusedRow(connection.id)
    } else {
      setModalPortal(connection.id)
    }
  }

  return {
    activeItem,
    handleCloseModal,
    handlePreviewResizeEnd,
    handleResetViewTypeToPlainBody,
    handleSelectPortal,
    listViewType: config.view,
    modalPortal,
    preview: config.preview,
  }
}
